/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState, useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { loader, isStreamingStarted, promptHeights } from '../Services/Redux/Reducers/commonSlice';
import { apiError, conversationList, isStream, isStopButtonTriggered, lastConversation } from '../Services/Redux/Reducers/chatSlice';
import { addchat, uniqueSessionHistory, getAppFeedBack, updateShopClicked } from "../Services/ApiServices/chatServices";
import ChatAPIService from "../Services/ChatAPIService";
import { resetSummedresponse, updateSummedResponse } from "../Services/CommonServices/helper";
import MessageHistory from "../CommonComponents/MessageHistory";
import cloneDeep from 'lodash/cloneDeep'
import { Cookies } from 'react-cookie-consent';
import { useAbortController } from "../Context/AbortControllerContext";
import { appLevelFeedback, likeApiError, showLikeDisLikeState } from "../Services/Redux/Reducers/feedBackSlice";
import { userPrompt } from "../Services/Redux/Reducers/userSlice";
import { getRandomImage, getDesktopRandomImage } from "../Services/CommonServices/helper";
import InputBox from './ChatLayoutComponents/InputBox';
import { motion } from "framer-motion";
 
function Chat(props) {
  const { createController, abortController } = useAbortController();
  const input = useSelector((state) => state.user.userPrompt)
  const [error, setError] = useState("");
  const customerId = Cookies?.get('ar_user_Id') ? Cookies.get('ar_user_Id') : "";
  const customerNo = Cookies?.get('ar_customer_no') ? Cookies.get('ar_customer_no') : "";
  const inputRef = useRef(null);
  const [isHeight, setHeight] = useState(false)
  const [isPlaceHolderVisible, setIsPlaceHolderVisible] = useState(true);
  const [isSendButtonDisabled, setIsSendButtonDisabled] = useState(true);
  const [sessionId, setSessionId] = useState(sessionStorage.getItem('persist_session') ? sessionStorage.getItem('persist_session') : null);
  const loading = useSelector((state) => state.common.isLoader)
  const isWarningclose = useSelector((state) => state.common.isWarning)
  const dispatch = useDispatch();
  const streamedResponse = useRef(resetSummedresponse());
  const [isResponseComplete, setIsResponseComplete] = useState(false);
  const [isStreaming, setIsStreaming] = useState(false);
  const conList = useSelector((state) => state.chat.conversationList);
  const [isiOS, setiOS] = useState(false);
  const effectRan = useRef(false);
  const [sessionChangeStatus, setSessionChangeStatus] = useState();
  const [lastConvoId, setLastConvoId] = useState("");
  const [apiLoading, setApiLoading] = useState(false);
  const streamingStarted = useSelector((state) => state.common.isStreamingStarted)
  const [downArrow, setShowDownArrow] = useState(false);
  const [submissionScroll, setSubmissionScroll] = useState(false);
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [promptHeiht, setPromptHeight] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(true);
  const bucketUrl = Cookies.get('bucketUrl') || props.bucketUrl;
 
  // used for unsubscribe the modal
  const handleFocus = () => {
    setIsKeyboardOpen(true);
    setIsPlaceHolderVisible(false);
  }
 
  const onHandleInputChange = (e) => {
    const inputValue = e.target.value
    dispatch(userPrompt(inputValue));
    setIsSendButtonDisabled(inputValue.trim() === '');
    if (inputValue.length > 136 || inputValue.length) {
      setHeight(true)
    }
    else {
      setHeight(false)
    }
  }
 
  const handleClickOutside = event => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setIsPlaceHolderVisible(input === '' || !input);
    }
  };
 
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [input]);
 
  useEffect(() => {
    if (!effectRan.current) {
      // effect applied - only on the FIRST mount
      if (input) {
        streaming(input);
      }
    }
    if (sessionId != null) {
      storeOldMessage();
      app_feedback()
    }
    return () => effectRan.current = true;
  }, []);
 
  // for input expansion
  useEffect(() => {
    inputRef.current.style.height = "0px";
    const scrollHeight = inputRef.current.scrollHeight;
    //condition to set input height
 
    if (isHeight === true) {
      inputRef.current.style.height = (scrollHeight) + "px";
    } else {
      inputRef.current.style.height = (scrollHeight - 10) + "px";
    }
  }, [input]);
 
  //iphone height fix
  useEffect(() => {
    let userAgent = window.navigator.userAgent.toLowerCase(),
      // macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i,
      // windowsPlatforms = /(win32|win64|windows|wince)/i,
      iosPlatforms = /iPad|iPhone|iPod/i;
      // safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (iosPlatforms.test(userAgent)) {
      setiOS(true);
    }
  }, []);
 
  useEffect(() => {
    if (window.innerWidth > 576) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
 
  }, [window.innerWidth]);
 
  const storeOldMessage = () => {
    if (process.env.REACT_APP_APPLICATION_VERSION === "Microsoft") {
      return
    }
    const params = [customerId, sessionId];
    try {
      uniqueSessionHistory(
        params,
        (response) => {
          // Chat History storing the messages
          // setData(response.data.data);
          dispatch(conversationList(response.data.data));
          dispatch(isStream(false))
        },
        (err) => {
          dispatch(apiError(err.message));
          dispatch(loader(false));
        }
      );
    }
    catch (err) {
      dispatch(apiError("An error occurred. Please try again"));
    }
  };
 
  //For Feedback check
  const app_feedback = () => {
    if (process.env.REACT_APP_APPLICATION_VERSION === "Microsoft") {
      return
    }
    const params = [customerId && customerId];
    try {
      getAppFeedBack(
        params,
        (response) => {
          // appLevel data
          dispatch(appLevelFeedback(response.data))
        },
        (err) => {
          dispatch(apiError("An error occurred. Please try again"));
          dispatch(loader(false));
        }
      );
    }
    catch (err) {
      dispatch(apiError("An error occurred. Please try again"));
    }
  };
 
  const handleLoader = () => {
    dispatch(loader(true))
    setIsSendButtonDisabled(true);
    setIsPlaceHolderVisible(true);
  };
 
  const handleStopResponse = () => {
    streamedResponse.current = resetSummedresponse();
    abortController();
    setApiLoading(false);
    setIsPlaceHolderVisible(true);
    dispatch(loader(false));
    dispatch(apiError(true));
    dispatch(showLikeDisLikeState(false))
    dispatch(isStopButtonTriggered(true))
    dispatch(isStreamingStarted(false));
    localStorage.setItem("stoppedResponseId", lastConvoId);
    dispatch(lastConversation(lastConvoId))
  };
 
  const callUpdateShopClicked = async (params) => {
    if (process.env.REACT_APP_APPLICATION_VERSION === "Microsoft") {
      return
    }
    try {
      await updateShopClicked(params, (response) => { // updating the shopClicked value    
        if (response.status === 200) {
          let conHis = cloneDeep(conList)
          const conIndex = conHis.findIndex((element) => element.uid === response.data.data.uid)
          conHis[conIndex] = response.data.data
          dispatch(conversationList(conHis));
        }
      }, (err) => {
      });
    } catch (err) {
      console.log('getting error in updating the shopClicked Value update', err);
    }
  }
 
  //update Shop Card Flag
  const updateShopCard = async (convoId, id) => {
    const params = {
      convoId,
      id
    }
    await callUpdateShopClicked(params);
  }
 
  const handleValueChange = (childValue) => {
    if (childValue.type === "quickshop") {
      let test = false
    if (childValue.shopClicked) {
      return
    }
    let conHis = cloneDeep(conList)
    const matchObject = conHis.find((element) => element.uid === childValue.convoId)
    matchObject && matchObject?.response?.products?.map((items) => {
      if (items.id === childValue.id) {
        if (items.shopClicked) {
          test = true
        }
      }
    })
 
      const { convoId, id } = childValue
      if(!test){
        updateShopCard(convoId, id);
      }
      storeOldMessage()
    }
    else if (childValue.type === "refresh" || childValue.type === "ProductCollectionListing" || childValue.type === "search") {
      dispatch(isStream(true))
        streamedResponse.current = resetSummedresponse();
        streaming(childValue.text, childValue.query, childValue.type === "ProductCollectionListing" ? true : false, childValue.type === "ProductCollectionListing" ? childValue.lookTitle : "");
    } else {
      handleStopResponse();
    }
  };
 
  useEffect(() => {
    // for scroll struck
    if (window.innerWidth > 576) {
      const timeout = setTimeout(() => {
        let button = document.querySelector(".follow_btn")
        if (button) {
          button.click();
        }
      }, 20);
      return () => clearTimeout(timeout);
    }
  }, [loading])
 
  const storeMessage = (conHis) => {
    if (process.env.REACT_APP_APPLICATION_VERSION === "Microsoft") {
      return
    }
    if (localStorage.getItem('storeChat') !== "false") {
      let convo = cloneDeep(conHis)
      let convoList = cloneDeep(conHis)
      let lastItem = convo.pop();
      const conIndex = convoList.findIndex((element) => element.uid === lastItem.uid)
      try {
        addchat(lastItem, (response) => { // Chat History storing the messages    
          convoList[conIndex]['showLikeDislike'] = false
          convoList[conIndex]['error'] = "Oops, Something went wrong"
          dispatch(conversationList(convoList));
        }, (err) => {
          console.log("An error occurred in add chat api call  in chat.", err.message);
          dispatch(loader(false));
          dispatch(apiError("An error occurred in add chat api call  in chat."));
        });
      }
      catch (err) {
        dispatch(loader(false));
        dispatch(apiError("An error occurred in add chat api call  in chat."));
        console.log("An error occurred in add chat api call  in chat.", err.message);
      }
    }
  }
  const streaming = async (input, query = "", isSingleLook = false, lookTitle = "") => {
    setIsScrolled(false);
    setPromptHeight(0);
    dispatch(isStreamingStarted(true));
    localStorage.setItem("stoppedResponseId", null);
    dispatch(lastConversation(""));
    dispatch(isStopButtonTriggered(false))
    const newController = createController();
    dispatch(likeApiError(true));
    dispatch(apiError(false));
    let sessionChange = false
    setSessionChangeStatus();
    let button = document.querySelector(".follow_btn")
    if (button) {
      button.click();
    }
    if (loading) return;
    if (input === undefined || input === '' || input === null) {
      return;
    }
    setApiLoading(true);
    handleLoader();
    streamedResponse.current = resetSummedresponse();
    setIsStreaming(true);
    let lastGeneratedId = crypto.randomUUID().slice(2)
    setLastConvoId(lastGeneratedId);
    let userParam = {
      uid: lastGeneratedId,
      backgroundImage: !isSingleLook ? `${bucketUrl}${getRandomImage()}` : "",
      desktopbackgroundImage: !isSingleLook ? `${bucketUrl}${getDesktopRandomImage()}` : `${bucketUrl}${getRandomImage()}`,
      requestDateTime: new Date().toString(),
      userId: customerId,
      customer_no: customerNo,
      messageId: "",
      question: input,
      response: {},
      sessionId: sessionId,
      sessionChange: sessionChange,
      showLikeDislike: false,
      error: "",
      likeStatus: "",
      feedBack: "",
      application_sessionId: "",
      isSingleLook: isSingleLook,
      lookTitle: lookTitle,
    }
    if (process.env.REACT_APP_NODE_ENV && process.env.REACT_APP_NODE_ENV === 'local') {
      userParam.application_sessionId = Cookies?.get('ar_user')
    }
    let conHistory = cloneDeep(conList)
    conHistory.push(userParam)
    dispatch(userPrompt(''));
    dispatch(showLikeDisLikeState(true))
    setError("");
    dispatch(conversationList(conHistory));
    setIsResponseComplete(true);
    try {
      const response = await ChatAPIService.postRequest(query !== "" ? query : input, sessionId, customerId, newController.signal)
      setApiLoading(false);
      var loopRunner = true;
      if (!response?.ok || !response.body) {
        let conHis = cloneDeep(conHistory)
        const conIndex = conHis.findIndex((element) => element.uid === lastGeneratedId)
        conHis[conIndex]['response'] = {
          responseType: "TextOnly",
          badIntentResponseCode: 'default',
          responseStatusCode: 500,
          errormessage: "An error occurred. Please try again",
          error: "An error occurred. Please try again"
        }
        dispatch(isStreamingStarted(false));
        dispatch(conversationList(conHis));
        storeMessage(conHis)
        loopRunner = false;
        dispatch(loader(false));
        dispatch(apiError(true));
        return;
      }
 
      const reader = response.body?.getReader();
      const decoder = new TextDecoder();
 
      var lastChunk = '';
      try {
        while (loopRunner && reader) {
          const { value, done } = await reader.read();
          if (done) {
            break;
          }
          const decodedChunk =
            lastChunk + decoder.decode(value, { stream: true });
          const responseArray = decodedChunk.split('\n\n');
          lastChunk = responseArray.pop() ?? '';
          updateResponseSteam(response, responseArray, conHistory, lastGeneratedId, sessionChange);
        }
      } catch (ex) {
        let conHis = cloneDeep(conHistory)
        const conIndex = conHis.findIndex((element) => element.uid === lastGeneratedId)
        if (ex.toString() === "AbortError: BodyStreamBuffer was aborted" || ex.toString() === "Oops, Request cancelled") {
          conHis[conIndex]['response'] = {
            // responseType: "Error",
            responseType: "Cancelled",
            errormessage: "Oops, Request cancelled",
            error: "Oops, Request cancelled"
          }
          dispatch(conversationList(conHis));
        } else {          
          conHis[conIndex]['response'] = {
            responseType: "TextOnly",
            responseStatusCode: response.status,
            badIntentResponseCode: "Other",
            errormessage: "An error occurred. Please try again",
            error: "An error occurred. Please try again"
          }
          dispatch(conversationList(conHis));
          storeMessage(conHis)
        }
        dispatch(loader(false));
        dispatch(apiError(true));
        return;
      }
    }
    catch (ex) {
      let conHis = cloneDeep(conHistory)
      const conIndex = conHis.findIndex((element) => element.uid === lastGeneratedId)
      if (ex.toString() === "AbortError: BodyStreamBuffer was aborted" || ex.toString() === "Oops, Request cancelled") {
        conHis[conIndex]['response'] = {
          // responseType: "Error",
          responseType: "Cancelled",
          errormessage: "Oops, Request cancelled",
          error: "Oops, Request cancelled"
        }
        dispatch(conversationList(conHis));
      } else {        
        conHis[conIndex]['response'] = {
          responseType: "Error",
          // responseType: "TextOnly",
          // responseStatusCode: 500,
          // badIntentResponseCode: "Other",
          errormessage: "An error occurred. Please try again",
          error: "An error occurred. Please try again"
        }
        dispatch(conversationList(conHis));
        storeMessage(conHis)
      }
      dispatch(loader(false));
      dispatch(apiError(true));
      return;
    }
    setIsResponseComplete(false);
  }
 
  const updateResponseSteam = (response, responseArray, conHistory, lastGeneratedId, sessionChange) => {    
    responseArray.forEach((responsestring) => {
      const stoppedResponseId = localStorage.getItem("stoppedResponseId");
      if (stoppedResponseId && lastGeneratedId === stoppedResponseId) {
        return;
      }
      responsestring = responsestring.replace('data:', '').trim();
      if (
        responsestring === '' ||
        responsestring === undefined ||
        responsestring === null
      ) {
        return;
      }
      if (responsestring === 'DONE') {
        return;
      }
      if (responsestring === 'error') {    // NEW BLOCK TO HANDLE ERROR CHUNK
        let conHis = cloneDeep(conHistory)
        const conIndex = conHis.findIndex((element) => element.uid === lastGeneratedId)
        conHis[conIndex]['response'] = {
          responseType: "Error",
          // responseType: "TextOnly",
          // responseStatusCode: 500,
          // badIntentResponseCode: "Other",
          errormessage: "An error occurred. Please try again",
          error: "An error occurred. Please try again"
        }
        dispatch(isStreamingStarted(false));
        dispatch(conversationList(conHis));
        storeMessage(conHis)
        dispatch(loader(false))
        return;
      }
      try {
        const apiResponseObject =
          JSON.parse(responsestring);
 
        const responseObject = JSON.parse(
          apiResponseObject.response,
        );
        if (apiResponseObject.sessionId) {
          if (sessionId == null || sessionId !== apiResponseObject.sessionId) {
            setSessionId(apiResponseObject.sessionId);
            sessionStorage.setItem('persist_session', apiResponseObject.sessionId)
            sessionChange = true
            setSessionChangeStatus(true)
          }
        }
        streamedResponse.current = updateSummedResponse(
          streamedResponse.current,
          { ...responseObject, messageId: apiResponseObject.activityId },
        );
        let conHis = cloneDeep(conHistory)
        let conIndex = conHis.findIndex((element) => element.uid === lastGeneratedId);
        conHis[conIndex]['messageId'] = streamedResponse.current.messageId
        conHis[conIndex]['response'] = streamedResponse.current
        conHis[conIndex]['response'].responseStatusCode = response.status
        conHis[conIndex]['response'].badIntentResponseCode = streamedResponse.current.badIntentResponseCode || ''
        conHis[conIndex]['sessionId'] = apiResponseObject.sessionId
        if (process.env.REACT_APP_NODE_ENV && process.env.REACT_APP_NODE_ENV === 'QA') {
          conHis[conIndex]['application_sessionId'] = apiResponseObject.sessionId;
        }
        conHis[conIndex]['sessionChange'] = sessionChange
        dispatch(conversationList(conHis));
        // Microsoft needs this please do not comment
        console.log('SessionID-', apiResponseObject.sessionId)
      }
      catch (ex) {
        let conHis = cloneDeep(conHistory)
        const conIndex = conHis.findIndex((element) => element.uid === lastGeneratedId)
        conHis[conIndex]['response'] = {
          responseType: "Error",
          // responseType: "TextOnly",
          // responseStatusCode: 500,
          // badIntentResponseCode: "Other",
          errormessage: "An error occurred. Please try again",
          error: "An error occurred. Please try again"
        }
        dispatch(conversationList(conHis));
        dispatch(isStreamingStarted(false));
        // dispatch(isResponseStopped(true));
        storeMessage(conHis)
        dispatch(loader(false))
        return;
      }
    });
  };
 
 
  // scroll to bottom arrow functionality
  useEffect(() => {
    const pageContainer = document.getElementById('pageContainer');
    let initialViewportHeight = pageContainer.clientHeight;
    const handleScroll = () => {
      const overflownspace = pageContainer.scrollHeight - pageContainer.scrollTop - pageContainer.clientHeight;      
      if (overflownspace > initialViewportHeight * 0.1) {        
        setShowDownArrow(true);
        setIsScrolled(true);
        if(conList && conList[conList.length - 1]?.response?.responseType !== 'TextOnly')
        setIsKeyboardOpen(false);
      } else {
        setShowDownArrow(false);
      }
      return;
    };
 
    const observer = new MutationObserver(() => {
      setTimeout(handleScroll, 100);
    });
    observer.observe(pageContainer, { childList: true, subtree: true });
    pageContainer.addEventListener('scroll', handleScroll);
    handleScroll();
    setTimeout(handleScroll, 300);
    return () => {
      pageContainer.removeEventListener('scroll', handleScroll);
      setShowDownArrow(false);
      observer.disconnect();
    }
  }, [conList, streamedResponse.current, isKeyboardOpen, downArrow]);
 
  const handleSubmissionScroll = async () => {
    const pageContainer = document.getElementById('pageContainer');
    const badgeElements = document.querySelectorAll('#badge-text');
    const lastBadge = badgeElements[badgeElements.length - 1];
 
    if (pageContainer && lastBadge) {
      await new Promise(resolve => setTimeout(resolve, 100));
      const badgePosition = lastBadge.offsetTop;
      const scrollOffset = 47;
 
      pageContainer.scrollTo({
        top: badgePosition - scrollOffset,
        behavior: 'smooth'
      });
    }
  };
 
 
  useEffect(() => {
    if (loading) {
      handleSubmissionScroll();
      setSubmissionScroll(true);
    }
 
    return () => {
      setTimeout(() => {
        setSubmissionScroll(false);
      }, 5000);
    }
 
  }, [loading])
 
  const initialViewportHeight = window.innerHeight;
 
 
  const renderDynamicEmptyDiv = useCallback(() => {
    if(loading && streamingStarted) {
      dispatch(isStreamingStarted(false));
    }
    const calculateHeight = () => {
      const viewportHeight = initialViewportHeight;

      const footer = document.querySelector('.inputbox-container') || document.querySelector('inputbox-container');
      const promptsModule = document.querySelector('.prompts') || document.querySelector('prompts');
      const likeNDislike = document.querySelector('.LikeNDislike') || document.querySelector('LikeNDislike');
 
      const getFullHeight = (element) => {
        if (!element) return 0;
        return element.getBoundingClientRect().height
      };
 
      const footerHeight = getFullHeight(footer)
      const promptsHeight = getFullHeight(promptsModule)
      setPromptHeight(promptsHeight)
      dispatch(promptHeights(promptsHeight))
      const likeNDislikeHeight = likeNDislike?.getBoundingClientRect().height || 0

      const availableHeight = viewportHeight - (
        footerHeight +
        likeNDislikeHeight +
        promptsHeight
      );
 
      const chatInstances = document.getElementsByClassName("chatInstance");
      const lastChatInstance = chatInstances[chatInstances.length - 1];
 
      if (!lastChatInstance) return 0;
 
      const chatInstanceHeight = lastChatInstance.getBoundingClientRect().height
 
      if (chatInstanceHeight >= availableHeight) {
        return 0;
      }
 
      const remainingHeight = availableHeight - chatInstanceHeight
      return Math.max(remainingHeight, 0);
    };
 
    return calculateHeight();
  }, []);
 
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        renderDynamicEmptyDiv();
      });
    });
 
    const chatInstances = document.getElementsByClassName("chatInstance");
    const lastChatInstance = chatInstances[chatInstances.length - 1];
    const chatWindow = document.querySelector('.chatwindow');
    const prompts = document.querySelector('.prompts');
    const warningModule = document.querySelector('.warningModule');
    const likeDislikeModule = document.getElementsByClassName("likeDislikeModule");
    const likeAndWarningWrapperModule = document.querySelector('.likeAndWarningWrapper')
    const likeNDislike = document.querySelector('.LikeNDislike')
 
    const footer = document.querySelector('.chat-input') || document.querySelector('chat-input');
    const footerGradient = document.querySelector('.footer-gradient') || document.querySelector('footer-gradient');
 
    if (lastChatInstance) {
      resizeObserver.observe(lastChatInstance);
    }
    if (chatWindow) {
      resizeObserver.observe(chatWindow);
    }
 
    if (likeDislikeModule[0]) {
      resizeObserver.observe(likeDislikeModule[0]);
    }

    if (warningModule) {
      resizeObserver.observe(warningModule);
    }
 
    if (likeAndWarningWrapperModule) {
      resizeObserver.observe(likeAndWarningWrapperModule);
    }
 
    if (likeNDislike) {
      resizeObserver.observe(likeNDislike);
    }
 
    if (prompts) {
      resizeObserver.observe(prompts);
    }
 
    if (footer) {
      resizeObserver.observe(footer);
    }
 
    if (footerGradient) {
      resizeObserver.observe(footerGradient);
    }
    renderDynamicEmptyDiv();

    return () => {
      resizeObserver.disconnect();
    };
  }, [conList, renderDynamicEmptyDiv]);
 
  const scrollToEnd = () => {
    const pageContainer = document.getElementById('pageContainer');
    pageContainer.scrollTo({
      top: pageContainer.scrollHeight - 100,
      behavior: 'smooth'
    });
    setShowDownArrow(false);
  };
 
  useEffect(() => {
    const preventScroll = (e) => {
      if (!streamedResponse?.current?.responseType && apiLoading) {
        // Preventing scroll
        e.preventDefault();
      }
    };
 
    const pageContainer = document.getElementById('pageContainer');
    if (pageContainer) {
      // Setting overflow to hidden
      if (!streamedResponse?.current?.responseType && apiLoading) {
        pageContainer.style.overflow = 'hidden';
      }
      else {
        pageContainer.style.overflow = 'auto';
      }
    }
 
    document.addEventListener('wheel', preventScroll, { passive: false });
    document.addEventListener('touchmove', preventScroll, { passive: false });
 
    return () => {
      const pageContainer = document.getElementById('pageContainer');
 
      if (pageContainer) {
        pageContainer.style.overflow = 'auto';
      }
      document.removeEventListener('wheel', preventScroll);
      document.removeEventListener('touchmove', preventScroll);
    };
  }, [streamedResponse?.current?.responseType, apiLoading]);
 
  const adjustDownArrowPosition = () => {
    const inputBox = document.getElementById('textarea_id');
    const downArrow = document.querySelector('.down-arrow');
 
    if (inputBox && downArrow) {
      const inputBoxHeight = inputBox.offsetHeight;
      downArrow.style.bottom = `${inputBoxHeight + 0}px`;
    }
  };
 
  useEffect(() => {
    const inputBox = document.getElementById('textarea_id');
 
    const handleInputChange = () => {
      adjustDownArrowPosition();
    };
 
    adjustDownArrowPosition();
 
    if (inputBox) {
      inputBox.addEventListener('input', handleInputChange);
    }
 
    return () => {
      if (inputBox) {
        inputBox.removeEventListener('input', handleInputChange);
      }
    };
  }, [input]);
 
  useEffect(() => {
    const pageContainer = document.getElementById('pageContainer');
 
    const handleScroll = () => {
      adjustDownArrowPosition();
    };
 
    if (pageContainer) {
      pageContainer.addEventListener('scroll', handleScroll);
    }
 
    return () => {
      if (pageContainer) {
        pageContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
 
  useEffect(() => {
    // Add a CSS rule to fix text wrapping issues
    const style = document.createElement('style');
    style.textContent = `
      .chatBody .message-text,
      .chatBody .message-content,
      .chatBody p,
      #s-propts .footer_btn {
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: break-word;
        hyphens: auto;
      }
    `;
    document.head.appendChild(style);
   
    return () => {
      document.head.removeChild(style);
    };
  }, []);
 
  return ( 
    <div className="pageMain" id="pageMain">
      <div className="d-flex flex-column">
        <div className={`homepage ${loading ? "homepageresize" : ""}`} style={{ backgroundColor: "#F2F3F5" }}>
          <div className="" id="pageContainer">
            <div className="chatwindow" id="chatwindow">
 
              <div className={`conversationlist chat_options`}>
                <div className={`container container-fluid px-0 px-md-3 chatContainerMain`}>
                  {
                    conList.length > 0 &&
                    <motion.div
                      className="chatBody"
                      initial={{ y: 50 }}
                      animate={{ y: 0 }}
                      transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                      <MessageHistory isAnswerComplete={!isResponseComplete} onValueChange={handleValueChange} effects={isStreaming} error="" responseId={lastConvoId} sessionChange={sessionChangeStatus} promptHeiht={promptHeiht} isScrolled={isScrolled} sessionId={sessionId}
                      /> 
                    </motion.div>
                  }
 
                </div>
 
                {
                  isMobile && isKeyboardOpen &&
                    <div style={{ height: `${140}px` }} />
                }
 
                {conList[conList.length - 1]?.response?.badIntentResponseCode !== "Other" &&
                    <div
                      id="suggest-propts"
                      className={`${promptHeiht === 0 && "prompVisiblity"} d-flex flex-column container prompts px-0 help-links ps-lg-3
                      ${
                        sessionChangeStatus && isWarningclose
                          ? "warning-spacing"
                          : sessionChangeStatus && !isWarningclose
                          ? "suggested-warning-spacing"
                          : "suggested-prompts-spacing"
                      }
                      ${loading ? "loading-height" : ""}`
                     }
                    >
                  {error === '' && !loading && (
                    <div id="s-propts">
                      {error === "" && (
                        <div className="footer-tags d-flex flex-column promtsFade" style={{ width: "fit-content", paddingBottom: "16px" }}>
                          <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                            width: "100%",
                          }}
                          >
                          {
                            streamedResponse.current.suggestedPrompts &&
                            streamedResponse.current.suggestedPrompts.map((suggested, i) => (
                              <button
                                name="suggestedPrompts"
                                className={`footer_btn ${i === 2 && 'last-footer-btn'} ${i === (streamedResponse.current.suggestedPrompts?.length) - 1 && 'last-btn'}`}
                                key={i}
                                onClick={() => {
                                  streaming(suggested)
                                }}
                                disabled={loading}
                              >
                                {suggested}
                              </button>
                            ))
                          }
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <InputBox
        input={input}
        loading={loading}
        inputRef={inputRef}
        isPlaceHolderVisible={isPlaceHolderVisible}
        isSendButtonDisabled={isSendButtonDisabled}
        isiOS={isiOS}
        setHeight={setHeight}
        setIsSendButtonDisabled={setIsSendButtonDisabled}
        handleFocus={handleFocus}
        onHandleInputChange={onHandleInputChange}
        streaming={streaming}
        handleStopResponse={handleStopResponse}
        setIsKeyboardOpen={setIsKeyboardOpen}
        setShowDownArrow={setShowDownArrow}
      />
     
      {!submissionScroll && downArrow && (
        <button
          className={`down-arrow`}
          onClick={scrollToEnd}
          style={{ bottom: `44px` }}
        >
          <img
            alt="down-arrow"
            src="./static/assets/scrollDown.svg"
          />
        </button>
      )}
    </div> 
  );
}
 
export default Chat;